/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


( function( $ ) {

	$( document ).ready( function() {
		$( '#PaginatedList' ).pagination( {
			item: '.loaded-item'
		} );

		// // Post listing Dropdown
		$( '#dropdown-category' ).change( function( e ) {
			e.preventDefault();
			
			if( $( this ).val() === '0' ) {
				return false;
			}
			
			if( $( this ).val() === 'All' ) {
				document.cookie = 'is_all=true; expires=1; path=/';
			}

			var link = $( 'option:selected', this ).data( 'link' );

			window.location.href = link;
		} );

	} );

} )( jQuery );
